import { put, call, take, delay } from "redux-saga/effects";
import * as actionCreators from "../actions/DisabledModulesActions";
import { httpGet, httpPost } from "./../../service";
import { VC_BASE_URL, API_SECRET_TOKEN, DISABLED_MODULES_API } from "../../config";

function* getDisabledModulesData(payload: { empId: string; }) {
    try {
        yield put(actionCreators.getDisabledModulesLoadingAction());
        const config = {
            headers: {
                // Authorization: `${payload.token}`,
                token: API_SECRET_TOKEN,
                "x-teams-origin": window.location.origin
            },
        };
        const { data } = yield httpPost(
            VC_BASE_URL
            + DISABLED_MODULES_API,
            {
                employeeId: payload.empId,
            },
            config
        );
        yield put(actionCreators.getDisabledModulesSuccessAction(data?.data));
    } catch (error: any) {
        yield put(
            actionCreators.getDisabledModulesErrorAction(error.response.data.error)
        );
    }
}


export function* watchGetDisabledModulesData() {
    while (true) {
        const { payload } = yield take(actionCreators.Actions.GET_DISABLED_MODULES);
        yield call(getDisabledModulesData, payload);
    }
}